import { ReactComponent as IconInformation } from "@/assets/svgs/information-circle.svg";
import { ButtonType, ButtonVariant } from "@/componentsDS/Button/Button.type";
import { useEffect, useState } from "react";
import CardConfigure from "@/componentsDS/Modal/CardConfigure";
import Button from "@/componentsDS/Button/Button";
import Modal from "@/componentsDS/Modal/Modal";
import Input from "@/componentsDS/Input/index";
import PropTypes from "prop-types";

export const EditModelTermModal = ({
	isModalVisible,
	hideModal,
	onEditHandler,
	name,
}) => {
	const [termName, setTermName] = useState("");
	const [isValid, setIsValid] = useState(false);

	const onTermClauseNameChange = (value) => {
		const trimmedValue = value.trim();
		const isValid = Boolean(trimmedValue.length > 0) && trimmedValue !== name;
		// Store the RAW value: pitstop's DSInput is fully controlled (value prop →
		// native input), so storing the trimmed value here would eat spaces as the
		// user types. Trim only for validation (above) and on submit (Done).
		setTermName(value);
		setIsValid(isValid);
	};

	useEffect(() => {
		if (isModalVisible) {
			setTermName(name)
			setIsValid(false);
		}
	}, [isModalVisible])

	return (
		<Modal visible={isModalVisible} variant="medium" close={hideModal}>
			<CardConfigure>
				<CardConfigure.Header>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">
								<div className="card-configure__icon card-configure__rounded-square card-configure__title__left">
									<IconInformation />
								</div>
								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										<div className="card-configure__title__right__top__title">
											Edit Template Name
										</div>
									</div>
								</div>
							</div>
						</div>
					</CardConfigure.Header.Title>
				</CardConfigure.Header>
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						<Input
							id="term-name"
							name="term-name"
							label="Template Name"
							required
							// pitstop's DSInput fires onChange with the native event, not the string
							// value (unlike admin-ui) — extract it so onTermClauseNameChange's
							// value.trim() doesn't crash. See model-term-form.jsx for the same fix.
							onChange={(e) => onTermClauseNameChange(e?.target?.value ?? '')}
							// Bind to STATE, not the `name` prop: pitstop's DSInput is fully
							// controlled (no internal state, unlike admin-ui's), so binding the
							// prop pins the display to the old name and typed text never shows.
							// The open-effect seeds termName from `name`.
							value={termName}
							fullWidth
						/>
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
				<CardConfigure.Footer>
					<CardConfigure.Footer.Left>
						<Button
							onClick={() => {
								hideModal();
							}}
							text="Cancel"
							type={ButtonType.GHOST}
							variant={ButtonVariant.STANDARD}
							className="account-settings__modal_term-action"
						/>
					</CardConfigure.Footer.Left>
					<CardConfigure.Footer.Right>
						<Button
							disabled={!isValid}
							onClick={() => onEditHandler(termName.trim())}
							text="Done"
							type={ButtonType.SOLID}
							variant={ButtonVariant.STANDARD}
							className="account-settings__modal_term-action"
						/>
					</CardConfigure.Footer.Right>
				</CardConfigure.Footer>
			</CardConfigure>
		</Modal>
	);
};

EditModelTermModal.propTypes = {
	isModalVisible: PropTypes.bool.isRequired,
	hideModal: PropTypes.func.isRequired,
	onEditHandler: PropTypes.func.isRequired,
	name: PropTypes.string,
};